import React, { Component, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Tooltip, Col, Row, Button, Radio } from 'antd'
import styles from './tenantInfoDialog.module.scss'
import dayjs from 'dayjs'
import * as apis from '@/apis'
const { TextArea } = Input;
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  labelAlign: "right"
};

@Form.create()
class ConfigureDialog extends Component {
  state = {
    loading: false,
    invitations: [],
    managers: []
  }

  handleSubmit = e => {
    const { tenantId, type, valuesType, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      this.setState({ loading: true })
      new Promise(function (resolve, reject) {
        // 一段耗时的异步操作
        resolve('成功') // 数据处理完成
      }
      ).then((res) => {
        this.props.form.resetFields()
        onSuccess(res)
        submitCallback && submitCallback({ type: type, valuesType: valuesType, data: values[`${valuesType}`], paytype: { pay_type: values.pay_type, express: values.express } })
      },  // 成功
        (err) => { console.log(err) } // 失败
      )
    });
  }

  render() {
    const { type, valuesType, row = {} } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form
    const disabled = this.state.invitations.length >= 30 || this.state.loading
    const mingzi = valuesType === 'address' ? '返件地址' : '反馈要求'
    return (
      <div>
        <Form
          layout="horizontal"
          {...formItemLayout}
          onSubmit={this.handleSubmit}>
          {valuesType === "address" ?
            <Form.Item label={"支付方式"}>
              {getFieldDecorator(`pay_type`, {
                initialValue: row.pay_type || 2
              })(<Radio.Group style={{ width: 380 }}>
                <Radio value={2}>到付</Radio>
                <Radio value={1}>寄付</Radio>
              </Radio.Group>)}
            </Form.Item> : ""
          }
          {valuesType === "address" ?
            <Form.Item label={"快递公司"}>
              {getFieldDecorator(`express`, {
                initialValue: row.express,
              })(<Input style={{ width: 380 }} placeholder="无要求" />)}
            </Form.Item> : ""
          }

          <Form.Item label={mingzi} required>
            {getFieldDecorator(`${valuesType}`, {
              initialValue: row[`${valuesType}`],
              rules: [{ required: true, message: `请输入${mingzi}` }],
            })(<TextArea style={{ width: 380 }} autoSize={{ minRows: 2, maxRows: 6 }} disabled={disabled} autoFocus placeholder={`请输入${mingzi}`} />)}
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button type="primary" disabled={disabled} htmlType="submit"> {type === "add" ? "确认添加" : "确认修改"}</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const TenantInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={680}
    visible={isOpen}
    onCancel={hide}>
    <ConfigureDialog onSuccess={hide}  {...ownProps} />
  </Modal>
)
export default sagaModal({
  name: 'CONFIGURE_DIALOG',
})(TenantInfoDialog)
